// extracted by mini-css-extract-plugin
export default {"meal-item":"MealItem_meal-item__wr0iz","meal":"MealItem_meal__df5TJ","name":"MealItem_name__6qVan","description":"MealItem_description__kARHs","price":"MealItem_price__L4q5n"};